module["exports"] = ["Снаб", "Торг", "Пром", "Трейд", "Сбыт"];